import { breakpoints, Stack, Input } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import type { ReactNode } from 'react';
import { cabinClasses } from '../../../constants/cabinClassesConstants';
import { CABIN_CLASS } from '../constants/formFields';
import CabinClassSelectNew from './CabinClassSelectNew';
import PassengersNew from './passengers/PassengersNew';

const { BUSINESS, ECONOMY, FIRST, PREMIUM_ECONOMY } = cabinClasses;
const isInLargeViewport = () => window.matchMedia(`(min-width: ${breakpoints._768})`).matches;

const inputGroupStyles = css`
  flex: 1;
  position: relative;
  width: calc(50% - 24px);
`;

const cabinClassStyles = css`
  flex: 1;
`;

type FormConstraintsType = {
  passengers: {
    maxNumberOfTravelers: number;
    isDisabled: boolean;
  };
} | null;

type PassengersAndCabinClassNewProps = {
  formConstraints?: FormConstraintsType;
};

type WrapperProps = { children: ReactNode };

const Wrapper = ({ children }: WrapperProps) =>
  isInLargeViewport() ? (
    <Input.Group className={inputGroupStyles}>{children}</Input.Group>
  ) : (
    <Stack spacing={24}>{children}</Stack>
  );

const PassengerAndCabinClassNew = ({ formConstraints }: PassengersAndCabinClassNewProps) => {
  const { t } = useTranslation();

  const cabinClassOptions = [
    { value: ECONOMY, label: t('Air.Search.Cabin.Button.Economy') },
    { value: PREMIUM_ECONOMY, label: t('Air.Search.Cabin.Button.PremiumEconomy') },
    { value: BUSINESS, label: t('Air.Search.Cabin.Button.Business') },
    { value: FIRST, label: t('Air.Search.Cabin.Button.Supersonic') },
  ];

  return (
    <Wrapper>
      <PassengersNew constraints={formConstraints?.passengers} />
      <CabinClassSelectNew
        cabinClasses={cabinClassOptions}
        className={cabinClassStyles}
        data-testid="searchForm-cabinClasses-dropdown"
        fieldName={CABIN_CLASS}
        label={t('Searchform.BookingClass.Label')}
        placeholder={t('Air.Search.Cabin.Placeholder')}
        shouldMarkInputAsRequired={false}
      />
    </Wrapper>
  );
};

export default PassengerAndCabinClassNew;
